import { Grid, Typography, useMediaQuery, useTheme } from '@material-ui/core';
import { globalStyles } from '../../styles/global.styles';
import { ReactComponent as IconRocket } from '../../assets/iconRocket.svg';
import iconBubble from '../../assets/iconBubble.svg';
import { errorPageStyles } from './ErrorPage.styles';
import errorPageTranslations from '../../common/utils/errorPageTranslations';
import CustomButton from '../../components/atoms/CustomButton';
import { IErrorPage } from './ErrorPageTypes';
import { useNavigate } from 'react-router-dom';

const ErrorPage: React.FC<IErrorPage> = ({ isNotFound }) => {
	const language =
		localStorage.getItem('lang') !== null
			? localStorage.getItem('lang')
			: window?.navigator?.language
			? window.navigator.language.split('-')[0]
			: 'es';
	const navigate = useNavigate();
	const globalClasses = globalStyles();
	const classes = errorPageStyles();
	const theme = useTheme();
	const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
	const renderLiteral = (language: string, literal: string) => {
		const langCode = isNotFound ? `${language}-notFound` : language;
		switch (langCode) {
			case 'ca':
				return errorPageTranslations[language][literal];
			case 'es':
				return errorPageTranslations[language][literal];
			case 'pt':
				return errorPageTranslations[language][literal];
			case 'ca-notFound':
				return errorPageTranslations[`${language}-notFound`][literal];
			case 'es-notFound':
				return errorPageTranslations[`${language}-notFound`][literal];
			case 'pt-notFound':
				return errorPageTranslations[`${language}-notFound`][literal];
			default:
				return errorPageTranslations.es[literal];
		}
	};

	return (
		<Grid
			container
			direction='row'
			justifyContent='space-between'
			className={classes.content}
		>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				className={`${globalClasses.flexJustifyCenter}`}
			>
				<Typography
					className={`${globalClasses.fw600} ${globalClasses.fontSize42} ${globalClasses.mb20}`}
				>
					{
						// eslint-disable-next-line @typescript-eslint/ban-ts-comment
						// @ts-ignore
						renderLiteral(language, 'mybank:errorpage:ups')
					}
				</Typography>
			</Grid>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				className={
					isDesktop
						? `${globalClasses.flexJustifyCenter}`
						: `${globalClasses.flexDirectionColumn} ${globalClasses.alignItemsCenter}`
				}
			>
				{isDesktop && <IconRocket />}
				<div
					className={
						isDesktop
							? `${globalClasses.flexDirectionColumn} ${globalClasses.flexJustifyCenter} ${globalClasses.pl29}`
							: `${globalClasses.flexDirectionColumn} ${globalClasses.flexJustifyCenter} ${globalClasses.w90}`
					}
				>
					<div className={globalClasses.flexJustifyCenter}>
						<Typography
							className={`${globalClasses.pb16} ${globalClasses.fontSize18} ${globalClasses.textCenter} ${globalClasses.w430} ${globalClasses.fw700} ${globalClasses.flexAlignCenter}`}
						>
							{
								// eslint-disable-next-line @typescript-eslint/ban-ts-comment
								// @ts-ignore
								renderLiteral(language, 'mybank:errorpage:errormsg:fatal')
							}
						</Typography>
					</div>
					<div className={globalClasses.flexJustifyCenter}>
						<div
							className={
								isDesktop ? `${classes.boxInfoWeb}` : `${classes.boxInfoMobil}`
							}
						>
							<div className={`${classes.boxRowIconText}`}>
								<img src={iconBubble} className={globalClasses.mr10} />
								<Typography
									className={`${classes.boxInfoText}`}
									variant='body1'
								>
									{
										// eslint-disable-next-line @typescript-eslint/ban-ts-comment
										// @ts-ignore
										renderLiteral(language, 'mybank:errorpage:errormsg2')
									}
								</Typography>
							</div>
							<Typography
								component={'span'}
								className={`${globalClasses.textCenter} ${globalClasses.textBold} ${classes.contactPhone}`}
							>
								{
									// eslint-disable-next-line @typescript-eslint/ban-ts-comment
									// @ts-ignore
									renderLiteral(language, 'mybank:errorpage:errortlf')
								}
							</Typography>
						</div>
					</div>
					{
						<div
							className={`${globalClasses.flexJustifyCenter} ${globalClasses.pt8} ${globalClasses.pb8}`}
						>
							<CustomButton
								onClick={() => navigate('/')}
								buttonType={'primary'}
								text={
									// eslint-disable-next-line @typescript-eslint/ban-ts-comment
									// @ts-ignore
									renderLiteral(language, 'mybank:errorpage:back-hometext')
								}
							/>
						</div>
					}
				</div>
				{!isDesktop && (
					<Grid item className={classes.rocketWrapper}>
						<IconRocket />
					</Grid>
				)}
			</Grid>
		</Grid>
	);
};

export default ErrorPage;
